enum RoleHierarchy {
  Admin = 0,
  SecurityAdminUser = 1,
  MemberUser = 2,
  AppUser = 3,
}

export default RoleHierarchy;
